export default {
  title: {
    text: "负极材料种类占比",
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)",
  },
  // legend: {
  //   orient: "vertical",
  //   left: 0,
  //   top: 80,
  //   data: ["人造石墨", "天然石墨", "其他"],
  // },
  series: [
    {
      name: "新能源负极材料使用",
      type: "pie",
      radius: ["50%", "60%"],
      center: ["50%", "60%"],

      emphasis: {
        label: {
          show: true,
          fontSize: "30",
          fontWeight: "bold",
        },
      },

      data: [
        { value: 0.7225, name: "人造石墨" },
        { value: 0.2011, name: "天然石墨" },
        { value: 0.0764, name: "其他" },
      ],
    },
  ],
};
